import React from 'react';
import styled from 'styled-components'
import { 
    EditorState, 
    ContentState,
    convertToRaw
} from 'draft-js';

import { Button, RichText, Animation } from 'components'
import { FaPlus, FaExclamation, FaCalendar, FaTag } from 'react-icons/fa'

import { itemContext } from 'context'

const Container = styled.div`
    margin: 0.5rem 0;
    width: ${props => `calc(100% - ${props.offset * 32}px)`};
`

const ButtonsContainer = styled.div`
    display: flex;
    align-items: center;
    padding: 0 0.25rem;
    margin-top: ${props => props.marginTop};
`

const InputContainer = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    margin-top: ${props => props.marginTop};
`

const TextContainer = styled.div`
    box-sizing: border-box;
    width: 100%;
    padding: 0.75rem;
    background-color: #474747;
    box-shadow: var(--box-shadow);
    border-radius: 5px;
    margin-bottom: 0.5rem;
`

const InputBlock = props => {
    const {
        item,
        type
    } = props
    // Constants //
    const buttonStyle = {
        color:'var(--secondary-accent-color)',
        borderColor:'var(--secondary-accent-color)',
        margin:'0 0.25rem',
        height:'0.6rem',
        width: '0.6rem',
        boxShadowColor: 'transparent'
    }
    
    const submitButtonStyle = {
        backgroundColor:'var(--focus-color)',
        margin:'0',
        fontWeight: 'bolder',
        color: 'white',
    }
    
    // Elements //
    let properties = {blocks: []}
    const buttons = 
    <InputContainer marginTop={properties['blocks'].length === 0 && '0.5rem'}>
        <ButtonsContainer>
            
            {/* Priority selector */}
            <Button tooltip='Priority' icon={<FaExclamation/>} iconOnly onSelect={() => {}}
                styles={{margin:'0 0.25rem 0 0', height: '0.6rem', width: '0.6rem', 
                    borderColor: itemContext.PRIORITY_COLOR[item.priority],
                    color: itemContext.PRIORITY_COLOR[item.priority],
                    hoverColor: itemContext.PRIORITY_COLOR[item.priority]
                }}/>

            {/* Schedule selector */}
            <Button tooltip='Schedule' icon={<FaCalendar/>} iconOnly styles={buttonStyle} onSelect={() => {}}/>

            {/* Tag selector */}
            <Button tooltip='Tag' icon={<FaTag/>} iconOnly styles={buttonStyle} onSelect={() => {}}/>                                    
        </ButtonsContainer>

        {/* Edit button */}
        <div style={{display: 'flex', alignItems: 'center'}}>
            <Button text='Cancel' onSelect={() => {}} styles={{margin:'0 0.25rem 0 0', boxShadowColor: 'transparent', backgroundColor: '#474747'}}/>
            <Button text='Create' onSelect={() => {}} styles={submitButtonStyle}/>
        </div>
    </InputContainer>

    if(type === 'input'){
        return (
            <Container offset={item['offset']}>
                
                    <TextContainer style={{overflowY:'hidden'}}>
                        <RichText key={item['content']} value={JSON.stringify(convertToRaw(EditorState.createWithContent(ContentState.createFromText(item['content'])).getCurrentContent()))} 
                            disableAutoUpdate editable={false} edit={false} placeholder='Add an item...'
                            styles={{
                                primaryColor: '#474747',
                                secondaryColor: '#141414',
                                width: '100%',
                                height: 'auto',
                                margin: 0,
                                padding: 0,
                                backgroundColor: 'transparent',
                            }}/>
        
                        {properties['blocks'].length > 0 ? 
                        <div style={{display: 'flex', flexWrap: 'wrap', padding: '0 0 0.4rem 0'}}>
                            {properties}
                        </div> : null}
                        <Animation animation='expand'>
                            <ButtonsContainer>
                                {buttons}
                            </ButtonsContainer>
                        </Animation>
                    </TextContainer>
            </Container>
        )
    } else {
        return (
            <div style={{display: 'flex', alignItems: 'center', fontSize: '0.8rem', cursor: 'pointer', marginTop: '0.5rem', alignSelf: 'flex-start'}}>
                <div style={{display: 'flex', padding: '0.5rem', borderRadius: '5px', backgroundColor: 'transparent'}}>
                    <FaPlus style={{color:'var(--focus-color)', paddingRight:'0.5rem'}}/>
                    <div>Add item</div>
                </div>
            </div>
        )
    }
}

export default InputBlock